import type { ReactNode } from 'react';
import { Link, type LinkProps } from '@tanstack/react-router';
import { MdSettings } from 'react-icons/md';

interface Props {
  to: LinkProps['to'];
  children: ReactNode;
}

export default function MultiSelectManageLink({ to, children }: Props) {
  return (
    <div className="border-0 border-t border-solid border-border px-sm py-xxs">
      <Link
        to={to}
        className="flex h-xl items-center gap-xxs rounded-sm px-xs text-button-sm text-primary no-underline"
        onPointerDown={(e) => e.stopPropagation()}
      >
        <MdSettings className="size-icon-xxs" />
        <span>{children}</span>
      </Link>
    </div>
  );
}
